module.exports = __webpack_public_path__ + "partner-banner.3e665e6246237f06dd56.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/partner-banner.png
// module id = ../../../../../src/assets/img/partner-banner.png
// module chunks = styles